(function () {
  "use strict";

  var USER_TEAM = "__USER__";
  var TOTAL_ROUNDS = 21;
  var TEAMS_PER_ROUND = 15;
  var TOTAL_PICKS = TOTAL_ROUNDS * TEAMS_PER_ROUND;
  var STORAGE_KEY = "yardsale-nll-fantasy-draft-v1";
  var AI_TEAMS = [
    "Georgia Swarm",
    "Toronto Rock",
    "San Diego Seals",
    "Buffalo Bandits",
    "Las Vegas Desert Dogs",
    "Colorado Mammoth",
    "Philadelphia Wings",
    "Ottawa Black Bears",
    "Calgary Roughnecks",
    "Oshawa FireWolves",
    "Rochester Knighthawks",
    "Vancouver Warriors",
    "Saskatchewan Rush",
    "Halifax Thunderbirds"
  ];
  var BASE_ORDER = [USER_TEAM].concat(AI_TEAMS);

  function qs(root, selector) { return root.querySelector(selector); }
  function qsa(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function ordinal(value) {
    var mod100 = value % 100;
    if (mod100 >= 11 && mod100 <= 13) return value + "th";
    var suffix = value % 10 === 1 ? "st" : value % 10 === 2 ? "nd" : value % 10 === 3 ? "rd" : "th";
    return value + suffix;
  }

  function roundForPick(overall) { return Math.floor((overall - 1) / TEAMS_PER_ROUND) + 1; }
  function pickInRound(overall) { return ((overall - 1) % TEAMS_PER_ROUND) + 1; }

  function teamForPick(overall) {
    var order = roundForPick(overall) % 2 === 1 ? BASE_ORDER : BASE_ORDER.slice().reverse();
    return order[(overall - 1) % TEAMS_PER_ROUND];
  }

  function deterministicNoise(team, playerName) {
    var input = team + "|" + playerName;
    var hash = 2166136261;
    for (var index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }
    return ((hash >>> 0) % 601) / 100 - 3;
  }

  function initials(team) {
    return team.split(" ").filter(function (word) {
      return word !== "Lacrosse" && word !== "Club";
    }).map(function (word) { return word.charAt(0); }).join("").slice(0, 3);
  }

  function playerStat(player) {
    if (player.position === "G") {
      return (player.svPct * 100).toFixed(1) + "% SV · " + player.wins + " W";
    }
    return player.pts + " PTS · " + player.g + " G · " + player.a + " A";
  }

  function initDraft(root) {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    var players = Array.isArray(window.YardsaleDraftPlayers) ? window.YardsaleDraftPlayers.slice() : [];
    var loading = qs(root, "[data-loading]");
    var interfaceNode = qs(root, "[data-interface]");

    if (!players.length) {
      loading.innerHTML = "<p>Player data could not be loaded. Please refresh the page.</p>";
      return;
    }

    players.sort(function (a, b) { return a.rank - b.rank; });
    var playerByName = {};
    players.forEach(function (player) { playerByName[player.name] = player; });

    var saveProgress = root.dataset.saveProgress === "true";
    var teamInput = qs(root, "[data-team-input]");
    var state = {
      selections: [],
      history: [],
      query: "",
      position: "ALL",
      status: "ALL",
      sortKey: "rank",
      sortDirection: "asc",
      activeTab: "players",
      teamName: root.dataset.teamName || "Yardsale Lacrosse Club"
    };

    function publicTeamName(team) { return team === USER_TEAM ? state.teamName : team; }

    function restore() {
      if (!saveProgress) return;
      try {
        var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
        if (!saved || !Array.isArray(saved.selections)) return;
        var restored = saved.selections.map(function (playerName, index) {
          var player = playerByName[playerName];
          if (!player) return null;
          return { overall: index + 1, team: teamForPick(index + 1), player: player };
        }).filter(Boolean);
        if (restored.length === saved.selections.length && restored.length <= TOTAL_PICKS) {
          state.selections = restored;
        }
        if (saved.teamName) state.teamName = String(saved.teamName).slice(0, 40);
      } catch (error) {
        // Browser storage is optional.
      }
    }

    function persist() {
      if (!saveProgress) return;
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
          teamName: state.teamName,
          selections: state.selections.map(function (selection) { return selection.player.name; })
        }));
      } catch (error) {
        // The simulator remains fully usable without browser storage.
      }
    }

    function draftedMap() {
      var map = {};
      state.selections.forEach(function (selection) { map[selection.player.name] = selection; });
      return map;
    }

    function availablePlayers() {
      var drafted = draftedMap();
      return players.filter(function (player) { return !drafted[player.name]; });
    }

    function rosterFor(team) {
      return state.selections.filter(function (selection) { return selection.team === team; }).map(function (selection) { return selection.player; });
    }

    function chooseAiPlayer(team) {
      var roster = rosterFor(team);
      var forwards = roster.filter(function (player) { return player.position === "F"; }).length;
      var backs = roster.filter(function (player) { return ["D", "T", "U"].indexOf(player.position) >= 0; }).length;
      var goalies = roster.filter(function (player) { return player.position === "G"; }).length;
      var selectionNumber = roster.length + 1;

      return availablePlayers().map(function (player) {
        var score = player.rating + deterministicNoise(team, player.name);
        if (player.position === "G") {
          if (goalies === 0) score += selectionNumber >= 2 ? 13 : 4;
          if (goalies >= 1) score -= 18;
          if (goalies >= 2) score -= 100;
        } else if (player.position === "F") {
          if (forwards < 3) score += 4;
          if (forwards >= 8) score -= 28;
        } else {
          if (backs < 3) score += 6;
          if (backs >= 8) score -= 28;
        }
        if (player.note) score += 2;
        return { player: player, score: score };
      }).sort(function (a, b) {
        return b.score - a.score || a.player.rank - b.player.rank;
      })[0].player;
    }

    function recommendations() {
      var roster = rosterFor(USER_TEAM);
      var hasGoalie = roster.some(function (player) { return player.position === "G"; });
      var hasBack = roster.some(function (player) { return ["D", "T", "U"].indexOf(player.position) >= 0; });
      return availablePlayers().map(function (player) {
        return {
          player: player,
          score: player.rating + (!hasGoalie && player.position === "G" ? 18 : 0) + (!hasBack && ["D", "T", "U"].indexOf(player.position) >= 0 ? 8 : 0)
        };
      }).sort(function (a, b) { return b.score - a.score; }).slice(0, 5).map(function (item) { return item.player; });
    }

    function toast(message) {
      var node = qs(root, "[data-toast]");
      node.textContent = message;
      node.classList.add("is-visible");
      window.clearTimeout(node._ysdTimer);
      node._ysdTimer = window.setTimeout(function () { node.classList.remove("is-visible"); }, 2600);
    }

    function makeSelection(playerName) {
      var nextOverall = state.selections.length + 1;
      if (nextOverall > TOTAL_PICKS || teamForPick(nextOverall) !== USER_TEAM) return;
      var player = playerByName[playerName];
      if (!player || draftedMap()[player.name]) return;

      state.history.push(state.selections.slice());
      if (state.history.length > 20) state.history.shift();
      state.selections.push({ overall: nextOverall, team: USER_TEAM, player: player });

      var cursor = nextOverall + 1;
      while (cursor <= TOTAL_PICKS && teamForPick(cursor) !== USER_TEAM) {
        var team = teamForPick(cursor);
        var aiPlayer = chooseAiPlayer(team);
        state.selections.push({ overall: cursor, team: team, player: aiPlayer });
        cursor += 1;
      }

      state.query = "";
      qs(root, "[data-search]").value = "";
      persist();
      render();
      toast(player.name + " added to " + state.teamName);
    }

    function filteredPlayers() {
      var drafted = draftedMap();
      var needle = state.query.trim().toLowerCase();
      return players.filter(function (player) {
        var isDrafted = Boolean(drafted[player.name]);
        var matchesQuery = !needle || (player.name + " " + player.team + " " + player.position).toLowerCase().indexOf(needle) >= 0;
        var matchesPosition = state.position === "ALL" || player.position === state.position;
        var matchesStatus = state.status === "ALL" || (state.status === "DRAFTED" ? isDrafted : !isDrafted);
        return matchesQuery && matchesPosition && matchesStatus;
      }).sort(function (a, b) {
        var comparison;
        if (["name", "team", "position"].indexOf(state.sortKey) >= 0) {
          comparison = String(a[state.sortKey]).localeCompare(String(b[state.sortKey]));
        } else {
          comparison = Number(a[state.sortKey]) - Number(b[state.sortKey]);
        }
        return state.sortDirection === "asc" ? comparison : -comparison;
      });
    }

    function renderClock() {
      var nextOverall = state.selections.length + 1;
      var complete = nextOverall > TOTAL_PICKS;
      var onClock = complete ? null : teamForPick(nextOverall);
      var latest = state.selections[state.selections.length - 1];
      var userRoster = rosterFor(USER_TEAM);
      var percent = Math.round((state.selections.length / TOTAL_PICKS) * 100);

      qs(root, "[data-clock-label]").textContent = complete ? "Fantasy draft complete" : (onClock === USER_TEAM ? state.teamName + " is on the clock" : publicTeamName(onClock) + " is selecting");
      qs(root, "[data-overall]").textContent = complete ? "Complete" : ordinal(nextOverall);
      qs(root, "[data-round]").textContent = complete ? "All 315 selections are in" : "Round " + roundForPick(nextOverall) + " · Pick " + pickInRound(nextOverall);
      qs(root, "[data-latest-player]").textContent = latest ? latest.player.name : "Draft ready";
      qs(root, "[data-latest-meta]").textContent = latest ? publicTeamName(latest.team) + " · " + latest.player.position : "Choose any available player";
      qs(root, "[data-picks-made]").textContent = state.selections.length + " picks made";
      qs(root, "[data-progress-percent]").textContent = percent + "%";
      qs(root, "[data-progress-bar]").style.width = percent + "%";
      qs(root, "[data-roster-count]").textContent = "Your roster: " + userRoster.length + "/21";
      qs(root, "[data-available-count]").textContent = availablePlayers().length + " available";
      qs(root, "[data-draft-count]").textContent = state.selections.length + "/" + TOTAL_PICKS;
      qs(root, "[data-full-draft-count]").textContent = state.selections.length + " completed picks";
      qs(root, "[data-undo]").disabled = state.history.length === 0;
      qs(root, "[data-roster-heading]").textContent = state.teamName;
    }

    function renderPlayerTable() {
      var rows = filteredPlayers();
      var drafted = draftedMap();
      var nextOverall = state.selections.length + 1;
      var canPick = nextOverall <= TOTAL_PICKS && teamForPick(nextOverall) === USER_TEAM;
      var recommendationNames = recommendations().map(function (player) { return player.name; });

      qs(root, "[data-player-rows]").innerHTML = rows.map(function (player) {
        var selection = drafted[player.name];
        var rowClass = selection ? "is-drafted" : recommendationNames.indexOf(player.name) >= 0 ? "is-recommended" : "";
        var status = selection ? "#" + selection.overall + " · " + publicTeamName(selection.team) : "Available";
        return "<tr class=\"" + rowClass + "\">" +
          "<td><span class=\"ysd__rank\">" + player.rank + "</span></td>" +
          "<td><strong>" + escapeHtml(player.name) + "</strong><small>" + escapeHtml(player.note || player.gp + " games played") + "</small></td>" +
          "<td><span class=\"ysd__position ysd__position--" + escapeHtml(player.position.toLowerCase()) + "\">" + escapeHtml(player.position) + "</span></td>" +
          "<td>" + escapeHtml(player.team) + "</td>" +
          "<td>" + escapeHtml(playerStat(player)) + "</td>" +
          "<td><b class=\"ysd__rating\">" + Number(player.rating).toFixed(1) + "</b></td>" +
          "<td><span class=\"ysd__status " + (selection ? "is-taken" : "is-available") + "\">" + escapeHtml(status) + "</span></td>" +
          "<td><button type=\"button\" class=\"ysd__select\" data-player-name=\"" + escapeHtml(player.name) + "\" " + (selection || !canPick ? "disabled" : "") + ">" + (selection ? "Taken" : "Select") + "</button></td>" +
        "</tr>";
      }).join("");
      qs(root, "[data-table-note]").textContent = "Showing " + rows.length + " of " + players.length + " rostered NLL players · Active, practice-roster and injured-list players included.";
    }

    function renderRecommendations() {
      var node = qs(root, "[data-recommendations]");
      if (!node) return;
      var nextOverall = state.selections.length + 1;
      var canPick = nextOverall <= TOTAL_PICKS && teamForPick(nextOverall) === USER_TEAM;
      node.innerHTML = recommendations().map(function (player, index) {
        return "<button type=\"button\" class=\"ysd__recommendation\" data-player-name=\"" + escapeHtml(player.name) + "\" " + (!canPick ? "disabled" : "") + ">" +
          "<b>" + (index + 1) + "</b><span><strong>" + escapeHtml(player.name) + "</strong><small>" + escapeHtml(player.position + " · " + playerStat(player)) + "</small></span><i>→</i>" +
        "</button>";
      }).join("");
    }

    function renderMiniRoster() {
      var roster = rosterFor(USER_TEAM);
      qs(root, "[data-mini-roster]").innerHTML = roster.length ? roster.map(function (player, index) {
        return "<div><b>" + (index + 1) + "</b><span><strong>" + escapeHtml(player.name) + "</strong><small>" + escapeHtml(player.position + " · " + player.team) + "</small></span></div>";
      }).join("") : "<p>No players selected yet.</p>";

      var recent = state.selections.slice(-8).reverse();
      qs(root, "[data-recent-picks]").innerHTML = recent.length ? recent.map(function (selection) {
        return "<div class=\"ysd__recent\"><b>#" + selection.overall + "</b><span><strong>" + escapeHtml(selection.player.name) + "</strong><small>" + escapeHtml(publicTeamName(selection.team)) + "</small></span></div>";
      }).join("") : "<p class=\"ysd__empty\">The draft begins with you.</p>";
    }

    function renderDraftGrid() {
      var html = state.selections.map(function (selection) {
        return "<article class=\"" + (selection.team === USER_TEAM ? "is-user" : "") + "\"><span>#" + selection.overall + "</span><b class=\"ysd__monogram\">" + escapeHtml(initials(publicTeamName(selection.team))) + "</b><div><strong>" + escapeHtml(selection.player.name) + "</strong><small>" + escapeHtml(publicTeamName(selection.team) + " · " + selection.player.position) + "</small></div></article>";
      }).join("");
      var nextOverall = state.selections.length + 1;
      if (nextOverall <= TOTAL_PICKS) {
        var team = teamForPick(nextOverall);
        html += "<article class=\"is-current\"><span>#" + nextOverall + "</span><b class=\"ysd__monogram\">" + escapeHtml(initials(publicTeamName(team))) + "</b><div><strong>On the clock</strong><small>" + escapeHtml(publicTeamName(team)) + "</small></div></article>";
      }
      qs(root, "[data-draft-grid]").innerHTML = html;
    }

    function renderRosters() {
      qs(root, "[data-roster-grid]").innerHTML = BASE_ORDER.map(function (team) {
        var roster = rosterFor(team);
        return "<article class=\"" + (team === USER_TEAM ? "is-user" : "") + "\"><header><b class=\"ysd__monogram\">" + escapeHtml(initials(publicTeamName(team))) + "</b><div><strong>" + escapeHtml(publicTeamName(team)) + "</strong><small>" + roster.length + "/21 selected</small></div></header><ol>" + roster.map(function (player) {
          return "<li><span>" + escapeHtml(player.name) + "</span><b>" + escapeHtml(player.position) + "</b></li>";
        }).join("") + "</ol></article>";
      }).join("");
    }

    function renderTabs() {
      qsa(root, "[data-tab]").forEach(function (button) {
        var active = button.dataset.tab === state.activeTab;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });
      qsa(root, "[data-view]").forEach(function (view) { view.hidden = view.dataset.view !== state.activeTab; });
    }

    function render() {
      renderClock();
      renderTabs();
      if (state.activeTab === "players") {
        renderPlayerTable();
        renderRecommendations();
        renderMiniRoster();
      } else if (state.activeTab === "draft") {
        renderDraftGrid();
      } else {
        renderRosters();
      }
    }

    root.addEventListener("click", function (event) {
      var playerButton = event.target.closest("[data-player-name]");
      if (playerButton && root.contains(playerButton)) {
        makeSelection(playerButton.dataset.playerName);
        return;
      }
      var tabButton = event.target.closest("[data-tab]");
      if (tabButton && root.contains(tabButton)) {
        state.activeTab = tabButton.dataset.tab;
        render();
        return;
      }
      var sortButton = event.target.closest("[data-sort]");
      if (sortButton && root.contains(sortButton)) {
        var key = sortButton.dataset.sort;
        if (state.sortKey === key) state.sortDirection = state.sortDirection === "asc" ? "desc" : "asc";
        else {
          state.sortKey = key;
          state.sortDirection = key === "rating" ? "desc" : "asc";
        }
        renderPlayerTable();
        return;
      }
      if (event.target.closest("[data-undo]")) {
        if (!state.history.length) return;
        state.selections = state.history.pop();
        persist();
        render();
        toast("Last turn undone");
        return;
      }
      if (event.target.closest("[data-restart]")) {
        if (!window.confirm("Restart the entire fantasy draft?")) return;
        state.history.push(state.selections.slice());
        state.selections = [];
        persist();
        render();
        toast("Draft restarted");
        return;
      }
      if (event.target.closest("[data-copy-roster]")) {
        var roster = rosterFor(USER_TEAM);
        var summary = state.teamName + " — NLL Fantasy Draft\n\n" + roster.map(function (player, index) {
          return (index + 1) + ". " + player.name + " — " + player.position + " · " + player.team;
        }).join("\n");
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(summary).then(function () { toast("Roster copied"); }).catch(function () { toast("Unable to copy roster"); });
        } else {
          toast("Copying is not supported in this browser");
        }
      }
    });

    qs(root, "[data-search]").addEventListener("input", function (event) {
      state.query = event.target.value;
      renderPlayerTable();
    });
    qs(root, "[data-position-filter]").addEventListener("change", function (event) {
      state.position = event.target.value;
      renderPlayerTable();
    });
    qs(root, "[data-status-filter]").addEventListener("change", function (event) {
      state.status = event.target.value;
      renderPlayerTable();
    });
    teamInput.addEventListener("change", function (event) {
      state.teamName = event.target.value.trim().slice(0, 40) || "Yardsale Lacrosse Club";
      teamInput.value = state.teamName;
      persist();
      render();
    });

    restore();
    teamInput.value = state.teamName;
    loading.hidden = true;
    interfaceNode.hidden = false;
    render();
  }

  function initializeAll(container) {
    var scope = container || document;
    qsa(scope, "[data-yardsale-draft]").forEach(initDraft);
    if (scope.matches && scope.matches("[data-yardsale-draft]")) initDraft(scope);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initializeAll(document); });
  else initializeAll(document);

  document.addEventListener("shopify:section:load", function (event) { initializeAll(event.target); });
})();
